<template>
  <div class="container-main-body">
    <!--按钮开始-->
    <div class="list-container">
      <div v-if="searchShow" class="search-container">
        <el-row>
          <el-col :span="4">
            <div class="search-form-label">页码：</div>
            <div class="search-form-controller">
              <el-input
                size="mini"
                placeholder="页码"
                clearable
                v-model="queryData.page"
              ></el-input>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="search-form-label">品番：</div>
            <div class="search-form-controller">
              <el-input
                size="mini"
                placeholder="品番"
                clearable
                v-model="queryData.merchandiseNumber"
              ></el-input>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="search-form-label" style="margin-top:5px;">点全：</div>
            <div class="search-form-controller">
              <el-select v-model="queryData.dianquan" size="mini">
                <el-option v-for="item in dianquanData" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="search-form-label">担当：</div>
            <div class="search-form-controller">
              <el-input
                size="mini"
                placeholder="担当"
                clearable
                v-model="queryData.undertake"
              ></el-input>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" style="text-align: center;">
            <el-button
              type="warning"
              size="mini"
              icon="el-icon-search"
              plain
              @click="searchHandler"
              >开始搜索</el-button
            >
            <el-button
              type="primary"
              size="mini"
              icon="el-icon-delete"
              plain
              @click="searchHandler('clear')"
              >清空</el-button
            >
            <el-button
              type="danger"
              size="mini"
              icon="el-icon-close"
              plain
              @click="showSearchHandler()"
              >关闭搜索</el-button
            >
          </el-col>
        </el-row>
      </div>
      <div class="list-btns-container">
        <el-button-group>
          <el-button
            v-for="btn in $store.state.currentLBtnList"
            :key="btn.id"
            :type="btn.button_type"
            size="mini"
            :icon="btn.button_icon"
            @click="handlerButtonDispatch(btn.fn)"
            >{{ btn.button_name }}</el-button
          >
          <el-autocomplete
            style="margin-left: 20px"
            size="mini"
            popper-class="my-autocomplete"
            v-model="queryData.product_name"
            :fetch-suggestions="querySearchAsync"
            placeholder="请输入样本册"
            @select="handleSelect"
            @blur="handblur"
          >
            <i
              class="el-icon-edit el-input__icon"
              slot="suffix"
              @click="handleIconClick"
            >
            </i>
            <template slot-scope="{ item }">
              <span>{{ item.name }}</span>
            </template>
          </el-autocomplete>
        </el-button-group>
      </div>
      <!--按钮结束-->
      <!--列表数据 开始-->
      <div class="el-table-container">
        <el-table :data="ds" size="mini" stripe border height="100%" style="width: 100% border:1px solid #d1d1d1" header-row-class-name="list-header-row"  row-class-name="list-row">
          <el-table-column label="样本册" width="250" prop="sampleName" align="center"></el-table-column>
          <el-table-column label="页码" prop="pageCount" width="120" align="center"></el-table-column>
          <el-table-column label="品番" prop="merchandiseNumber" width="120" align="center"></el-table-column>
          <el-table-column label="点全" prop="dianquan" width="120" align="center"></el-table-column>
          <el-table-column label="担当" prop="undertake" width="120" align="center"></el-table-column>
          <el-table-column label="定数" prop="dingshu" width="120" align="center" ></el-table-column>
          <el-table-column label="前期" prop="qianqi" width="120" align="center"></el-table-column>
          <el-table-column label="中期" prop="zhongqi" width="120" align="center"></el-table-column>
          <el-table-column label="后期" prop="houqi" width="120" align="center" ></el-table-column>
          <el-table-column label="无限制" prop="wuxianzhi" width="120" align="center"></el-table-column>
          <el-table-column label="总数" prop="total" width="120" align="center"></el-table-column>
          <el-table-column align="center"></el-table-column>
        </el-table>
      </div>
      <div class="pagination-container">
        <el-pagination
          background
          :current-page="queryData.pn"
          :page-size="queryData.pageSize"
          :total="queryData.totalCount"
          :page-sizes="[10, 15, 20, 25, 30, 50, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="pageSizeChange"
          @current-change="pageChange"
        ></el-pagination>
      </div>
    </div>
    <!--列表数据 结束-->
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      ds: [],
      dsDetail: [],
      // 分页
      queryData: {
        product_id: "",
        product_name: "",
        page: "",
        merchandiseNumber: "",
        dianquan:'',
        undertake:'',
        pn: 1, // 页码
        pageSize: 20, // 每页条数
        totalCount: 0 // 数据总条数
      },
      searchShow: false,
      operator_id: sessionStorage.getItem("operator_id"),
      page: "",
      merchandiseNumber: "",
      dianquanData:[{id:'所有',name:'所有'},{id:'全',name:'全'},{id:'不全',name:'不全'}]
    };
  },
  created: function() {},
  mounted: function() {
    this.loadProduct();
  },
  methods: {
    // 按钮 点击 调度方法
    handlerButtonDispatch: function(fn, args) {
      var _this = this;
      if (typeof _this[fn] === "function") {
        _this[fn].apply(_this, args);
      } else {
        console.log("warning: the method is not exist");
      }
    },
    // 样本册搜索
    loadProduct: function() {
      let _this = this;
      _this.queryData.product_count = "";
      _this.get(_this.$apis.getInstoreProduct, {}, function(res) {
        _this.productList = res.data.dataList;
      });
    },
    querySearchAsync: function(queryString, cb) {
      this.product_check = "false";
      var results = queryString
        ? this.productList.filter(this.createStateFilter(queryString))
        : this.productList;

      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        cb(results);
      }, 500 * Math.random());
    },
    createStateFilter: function(queryString) {
      return product => {
        return product.name.indexOf(queryString) > -1;
      };
    },
    handleSelect: function(item) {
      let _this = this;
      _this.product_check = "true";
      _this.queryData.product_name = item.name;
      _this.queryData.product_id = item.id;
      _this.loadData();
    },
    handleIconClick: function(ev) {
      console.log(ev);
    },
    handblur: function() {
      if (this.product_check === "false") {
        this.queryData.product_name = "";
      }
    },
    // 加载数据
    loadData: function() {
      let _this = this;
      _this.post(_this.$apis.getMaterialSummaryList1, this.queryData, function(
        res
      ) {
        let _json = res.data;
        if (_json.status && _json.status === "logout") {
          _this.logout();
        } else {
          _this.ds = _json.datalist;
          _this.queryData.totalCount = _json.totalCount;
        }
      });
    },
    searchHandler: function(_type) {
      this.queryData.pn = 1;
      if (_type === "clear") {
        this.queryData.page = "";
        this.queryData.merchandiseNumber = "";
        this.queryData.dianquan = '';
        this.queryData.undertake = '';
      }
      if (this.queryData.product_name === "") {
        this.$message({
          type: "error",
          message: "请先选择样本册"
        });
        return false;
      } else {
        this.loadData();
      }
    },
    showSearchHandler: function() {
      this.searchShow = !this.searchShow;
    },
    // 刷新事件
    refreshHandler: function() {
      if (this.queryData.product_name === "") {
        this.$message({
          type: "error",
          message: "请先选择样本册"
        });
        return false;
      } else {
        this.loadData();
      }
    },
    // 页码改变
    pageSizeChange: function(pageSize) {
      this.queryData.pn = 1;
      this.queryData.pageSize = pageSize;
      if (this.queryData.product_name === "") {
        this.$message({
          type: "error",
          message: "请先选择样本册"
        });
        return false;
      } else {
        this.loadData();
      }
    },
    pageChange: function(pn) {
      this.queryData.pn = pn;
      if (this.queryData.product_name === "") {
        this.$message({
          type: "error",
          message: "请先选择样本册"
        });
        return false;
      } else {
        this.loadData();
      }
    },
    // 导出excel
    exportHandler: function() {
      let _this = this;
      if (_this.queryData.product_name === "") {
        _this.$message({
          type: "error",
          message: "请先选择样本册"
        });
        return false;
      } else {
        _this.post(
          _this.$apis.exportMaterialSummaryList1,
          _this.queryData,
          function(res) {
            let _json = res.data;
            if (_json.fileUrl !== "") {
              window.location = _this.$apiroot + _json.fileUrl;
            } else {
              _this.$router.push({
                path: "/"
              });
            }
          }
        );
      }
    }
  },
  components: {}
};
</script>
